/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{position:relative;display:flex;flex-direction:column}.loader[_ngcontent-%COMP%]{left:48%;position:absolute;top:-30px;z-index:1}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/shared/data-table-ajax/data-table-ajax.component.scss.shim.ngstyle.js.pre-build-optimizer.js